import React from "react";

const TimelineItem = ({ event, index }) => {
  return (
    <li className="mb-12 sm:mb-16 md:mb-20 ms-4 sm:ms-6 md:ms-7">
      {/* Timeline Icon */}
      <span>
        <img
          className="absolute w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full -start-4 sm:-start-5 md:-start-6 ring-2 ring-white object-cover"
          src={event.icon}
          alt="Timeline icon"
        />
      </span>

      {/* Content Container - All content left-aligned from same starting point */}
      <div className="ml-6 sm:ml-12 md:ml-16 lg:ml-20">
        {/* Title and Badge Container */}
        <div className="mb-2 sm:mb-3">
          {/* Title - Left aligned, proper line wrapping */}
          <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold text-white leading-tight mb-2 text-left">
            {event.title}
          </h3>
        </div>

        {/* Date - Left aligned */}
        <time className="block mb-3 sm:mb-4 text-sm sm:text-base md:text-lg font-normal text-[#ffcd29] leading-none text-left">
          {event.date}
        </time>

        <div className="mb-4 sm:mb-6 text-sm sm:text-base font-normal text-gray-400 leading-relaxed text-left">
          <p className="whitespace-pre-line">{event.description}</p>
        </div>

        {event.images && event.images.length > 0 && (
          <div className="mb-4 sm:mb-6">
            <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-gray-800">
              {event.images.map((image, imgIndex) => (
                <div
                  key={imgIndex}
                  className="flex-shrink-0 group overflow-hidden rounded-lg border border-gray-200 hover:border-yellow-400 transition-all duration-300"
                >
                  <a
                    href={event.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block"
                  >
                    <div className="w-32 h-24 sm:w-40 sm:h-30 md:w-48 md:h-36 lg:w-56 lg:h-40 overflow-hidden">
                      <img
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        src={image}
                        alt={`${event.title} - Photo ${imgIndex + 1}`}
                        loading="lazy"
                      />
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Link Button - Simple "more..." text, left aligned */}
        {event.link && event.link !== "#" && (
          <div className="text-left">
            <a
              href={event.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-sm sm:text-base text-[#FFCD29] hover:text-yellow-300 underline hover:no-underline transition-colors duration-200 font-medium"
            >
              more...
            </a>
          </div>
        )}
      </div>
    </li>
  );
};

export default TimelineItem;
